export default "__VITE_ASSET__B9$KoEce__"